import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Oven = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path
        d="M3.334 7.952c0-.184.15-.333.333-.333H13c.184 0 .334.15.334.333v5.334c0 .184-.15.333-.334.333H3.667a.333.333 0 0 1-.333-.333V7.952Zm.667.334v4.666h8.666V8.286H4.001Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M5.668 9.952c0-.184.15-.333.333-.333h4.667a.333.333 0 1 1 0 .667H6a.333.333 0 0 1-.333-.334Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path d="M10 4.618a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM12.667 4.618a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z" />
      <path
        d="M3 2.286a1 1 0 0 0-1 1v10.666a1 1 0 0 0 1 1h10.667a1 1 0 0 0 1-1V3.286a1 1 0 0 0-1-1H3.001Zm-1.666 1c0-.92.746-1.667 1.667-1.667h10.666c.92 0 1.667.746 1.667 1.667v10.666c0 .92-.746 1.667-1.667 1.667H3.001c-.92 0-1.667-.747-1.667-1.667V3.286Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M3.334 3.952c0-.184.15-.333.333-.333h2a.333.333 0 1 1 0 .667h-2a.333.333 0 0 1-.333-.334ZM1.334 5.952c0-.184.15-.333.333-.333H15a.333.333 0 1 1 0 .667H1.667a.333.333 0 0 1-.333-.334Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

Oven.category = 'product-category';

Oven.displayName = 'Oven';
